import { render, staticRenderFns } from "./DoubleCameraIndex.vue?vue&type=template&id=ffe0ad7a&scoped=true&"
import script from "./DoubleCameraIndex.vue?vue&type=script&lang=js&"
export * from "./DoubleCameraIndex.vue?vue&type=script&lang=js&"
import style0 from "./DoubleCameraIndex.vue?vue&type=style&index=0&id=ffe0ad7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe0ad7a",
  null
  
)

export default component.exports